module.exports = __webpack_public_path__ + "img/acceso_denegado.3652bca3.png";